import { ICampaign } from "@/models";
import { updateCampaign } from "@/services";
import { toastError, toastSuccess } from "@/utils";
import { Toast } from "primereact";
import { useMutation, useQueryClient } from "react-query";

export const useUpdateCampaignData = (toast: React.RefObject<Toast>) => {
 const queryClient = useQueryClient();
 const {
  mutate,
  isLoading: updateCampaignIsLoading,
  isSuccess: updateCampaignIsSuccess,
 } = useMutation(
  async (campaign: Omit<ICampaign, "imageUrl">) =>
   await updateCampaign(campaign),
  {
   onSuccess: () => {
    queryClient.invalidateQueries("campaigns");
    toastSuccess(toast, "Campaign Updated");
   },
   onError: () => {
    toastError(toast, "Campaign not Updated");
   },
  },
 );
 return {
  mutate,
  updateCampaignIsLoading,
  updateCampaignIsSuccess,
 };
};
